<template>
  <div class="bc-report-governance">
    <type-container title="体检事实">
      <pagination-table
        :key="queryQA.key"
        :is-question="queryQA.isQuestion"
        :title="queryQA.title"
        :table-data="queryQA.entities"
        :table-props="queryQA.props"
        :loading="queryQA.loading"
        :show-total="queryQA.showTotal"
      />
    </type-container>
    <report-analysis
      type="governance"
      kind="analysis"
    />
    <report-analysis
      type="governance"
      kind="suggestion"
    />
  </div>
</template>

<script>
import PaginationTable from '@/components/table/PaginationTable'
import ReportAnalysis from './ReportAnalysis'
import TypeContainer from '@/components/report/ReportTypeContainer'
import mixin from '@/mixins/lawExamReport.js'
export default {
  name: 'BcReportGovernance',
  components: { PaginationTable, ReportAnalysis, TypeContainer },
  mixins: [ mixin ],
  computed: {
    typeTables () {
      return [
        { key: 'queryQA', source: this.queryQA }
      ]
    }
  },
  created () {
    this.queryQA.type = 1
  }
}
</script>

<style lang="stylus">
.bc-report-governance
  background-color #fff
</style>
